import React, { useState } from 'react';
import { Box, Flex, Table, Tbody, Td, Text, Th, Thead, Tr,} from "@chakra-ui/react";
import { useTranslation } from 'react-i18next';
import Pagination from "components/ui/pagination/Pagination";

export default function FilteredDataTable({data}) {
    const { t } = useTranslation();

    /* --------------------------------------------- Start Pagination  -----------------------------------------------*/
      const recordsPerPage = 10;
      const [currentPageActive, setCurrentPageActive] = useState(1);
      const prePage = (currentPage, setCurrentPage) => {
        if (currentPage > 1) {
          setCurrentPage(currentPage - 1);
        }
      };
    
      const nextPage = (currentPage, setCurrentPage, npage) => {
        if (currentPage < npage) {
          setCurrentPage(currentPage + 1);
        }
      };
    
      const calculateRecords = (data, currentPage, recordsPerPage) => {
        const firstIndex = (currentPage - 1) * recordsPerPage;
        const lastIndex = Math.min(currentPage * recordsPerPage, data?.length);
        return data?.slice(firstIndex, lastIndex);
      };
    
    // Calculate records for activeDiscounts
    const inventoryAnalysisFilteredData = calculateRecords(
        data,
        currentPageActive,
        recordsPerPage
      );
 /* --------------------------------------------- End Pagination  -----------------------------------------------*/
  return <>
    <>
    <Table>
        <Thead>
                <Tr>
                    <Th>{t("pages.reports.reports_tables.item")}</Th>
                    <Th>{t("pages.reports.reports_tables.sku")}</Th>
                    <Th>{t("pages.reports.reports_tables.barcode")}</Th>
                    <Th>{t("pages.reports.reports_tables.ideal_cost")}</Th>
                    <Th>{t("pages.reports.reports_tables.wate_from_order")}</Th>
                    <Th>{t("pages.reports.reports_tables.quantity_adjustment")}</Th>
                    <Th>{t("pages.reports.reports_tables.wate_from_production")}</Th>
                    <Th>{t("pages.reports.reports_tables.count_varience")}</Th>
                    <Th>{t("pages.reports.reports_tables.actual_cost")}</Th>
                    <Th>{t("pages.reports.reports_tables.ideal_percentage")}</Th>
                    <Th>{t("pages.reports.reports_tables.actual_percentage")}</Th>
                    <Th>{t("pages.reports.reports_tables.variance_cost")}</Th>
                    <Th>{t("pages.reports.reports_tables.variance_percentage")}</Th>
                    <Th>{t("pages.reports.reports_tables.diversion")}</Th>
                </Tr>
        </Thead>
        <Tbody>
            {
            inventoryAnalysisFilteredData?.map((item, index) => (
                <Tr key={index}>  
                    <Td>{item?.ProductName}</Td>
                    <Td>{item?.Ref}</Td>
                    <Td>{item?.ItemBarcode}</Td>
                    <Td> {item?.IdealCost}  </Td>
                    <Td> {item?.WasteFromOrder} </Td>
                    <Td> {item?.QuantityAdj} </Td>
                    <Td> {item?.WasteFromProduction} </Td>
                    <Td> {item?.CountVariance} </Td>
                    <Td>{item?.ActualCost}</Td>
                    <Td>{item?.IdealPercentage}</Td>
                    <Td>{item?.ActualPercentage}</Td>
                    <Td> {item?.VarianceCost}  </Td>
                    <Td> {item?.VariancePercentage} </Td>
                    <Td> {item?.Diversion} </Td>
                </Tr>
            ))
            }
        </Tbody>
    </Table>
    <Pagination
           currentPage={currentPageActive}
            setCurrentPage={setCurrentPageActive}
            npage={Math.ceil(data?.length / recordsPerPage)}
            prePage={() => prePage(currentPageActive, setCurrentPageActive)}
            nextPage={() =>
              nextPage(
                currentPageActive,
                setCurrentPageActive,
                Math.ceil(data?.length / recordsPerPage)
                )
              }
        />
    </>

  </>
};
